<template>
  <div class="hello">
    <md-dialog-confirm
      class="confirm"
      :md-active.sync="confirmDelete"
      md-title=""
      md-content="Are you sure to delete this group?"
      md-confirm-text="Yes, Delete!"
      md-cancel-text="No"
      @md-cancel="onCancel"
      @md-confirm="onDeleteConfirm"
    />
    <div class="filters md-elevation-4">
      <div class="md-layout">
        <div class="md-layout-item p10">
          <md-field class="md-field-select">
            <label for="group">Status</label>
            <md-select v-model="filterStatus" name="status" id="status">
              <md-option value="-">All</md-option>
              <md-option
                :key="key"
                v-for="(status, key) in statuses"
                :value="status"
                >{{ key | capitalize }}</md-option
              >
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item text-right">
          <group-edit @updateQuery="onUpdateQuery" :group="{}" :isNew="true" />
        </div>
      </div>
    </div>
    <h1>All Groups</h1>
    <!-- Apollo watched Graphql query -->
    <ApolloQuery
      ref="groups"
      @result="onResult"
      :query="query"
      :variables="{
        offset,
        limit,
        order: order,
        direction: orderDirection,
        filter: { status: filterStatusFormated },
      }"
    >
      <template slot-scope="{ result: { loading, error, data } }">
        <!-- Loading -->
        <div v-if="loading" class="loading apollo">Loading...</div>

        <!-- Error -->
        <div v-else-if="error" class="error apollo">An error occured</div>

        <!-- Result -->
        <div v-else-if="data" class="result table md-elevation-4">
          <loading :active="showLoader" :is-full-page="false"></loading>
          <table width="100%">
            <thead>
              <tr>
                <th>
                  <a
                    :class="{
                      active: order == 'label',
                      desc: direction == true,
                    }"
                    @click="onOrder('label')"
                    href="javascript:void(0);"
                    >Group Name</a
                  >
                </th>
                <th>
                  <a
                    :class="{
                      active: order == 'createdAt',
                      desc: direction == true,
                    }"
                    @click="onOrder('createdAt')"
                    href="javascript:void(0);"
                    >Created Date</a
                  >
                </th>
                <th>
                  <a
                    :class="{
                      active: order == 'status',
                      desc: direction == true,
                    }"
                    @click="onOrder('status')"
                    href="javascript:void(0);"
                    >Status</a
                  >
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr :key="group.id" v-for="group in data.groups.edges">
                <td>
                  {{ group.label }}
                </td>
                <td>
                  {{ parseInt(group.createdAt) | moment("MM/DD/YYYY") }}
                </td>
                <td>{{ getStatusLabel(group.status) | capitalize }}</td>
                <td class="controll">
                  <group-edit
                    @updateQuery="onUpdateQuery"
                    :group="group"
                  /><md-button
                    @click="showDelete(group.id)"
                    class="md-icon-button"
                    ><md-icon>delete</md-icon></md-button
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <paginator
            @prev="onPrev"
            @next="onNext"
            :page="page"
            :pages="pages"
            :limit="limit"
            :count="count"
            :total="totalCount"
          />
        </div>
        <!-- No result -->
        <div v-else class="no-result apollo">No result</div>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
import Paginator from "./Paginator";
import GroupEdit from "./GroupEdit";
import GroupStatuses from "../helpers/GroupStatuses";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "Groups",
  props: ["user", "isAdmin"],
  computed: {
    pages() {
      return Math.ceil(this.totalCount / this.limit) - 1;
    },
    offset() {
      return this.page * this.limit;
    },
    orderDirection() {
      return this.direction ? "DESC" : "ASC";
    },
    filterStatusFormated() {
      return this.filterStatus === "-" ? null : this.filterStatus;
    },
  },
  data() {
    return {
      showLoader: false,
      page: 0,
      limit: 10,
      totalCount: 0,
      count: 0,
      query: require("../graphql/Groups.gql"),
      order: "label",
      direction: 0,
      filterStatus: "-",
      statuses: GroupStatuses.getStatuses(),
      group_id: null,
      confirmDelete: false,
    };
  },
  components: {
    Paginator,
    GroupEdit,
    Loading,
  },
  methods: {
    onCancel() {
      this.showDialog = false;
    },
    showDelete(id) {
      this.group_id = id;
      this.confirmDelete = true;
    },
    onDeleteConfirm() {
      this.confirmDelete = false;
      this.delete();
    },
    async delete() {
      if (this.group_id) {
        await this.$apollo
          .mutate({
            mutation: require("../graphql/DeleteGroup.gql"),
            variables: {
              id: this.group_id,
            },
          })
          .then(() => {
            this.group_id = null;
            this.$refs["groups"].$apollo.queries.query.refetch();
          })
          .catch(() => {
            this.group_id = null;
            this.$refs["groups"].$apollo.queries.query.refetch();
          });
      }
    },
    onPrev() {
      if (this.page > 0) {
        this.page--;
      }
    },
    onNext() {
      if (this.page < this.pages) {
        this.page++;
      }
    },
    onResult(data) {
      let totalCount = data.data.groups.count;
      this.totalCount = totalCount;
      this.count = data.data.groups.edges.length;
      this.showLoader = false;
    },
    onUpdateQuery() {
      this.$refs["groups"].$apollo.queries.query.refetch();
    },
    onOrder(field) {
      if (this.order == field) {
        this.direction = !this.direction;
      } else {
        this.direction = 0;
        this.order = field;
      }
    },
    getStatusLabel(id) {
      return GroupStatuses.getKeyByValue(id);
    },
    showLoaderFn() {
      this.showLoader = true;
    },
  },
  watch: {
    page() {
      this.showLoaderFn();
    },
    orderDirection() {
      this.page = 0;
      this.showLoaderFn();
    },
    filterStatusFormated() {
      this.page = 0;
      this.showLoaderFn();
    },
  },
};
</script>